import React from "react";
import Switch from "@mui/material/Switch";
import { useClinicContext } from "../../contexts";
import { CheckinStatus } from "../../types";

interface ClinicTableProps {
	checkInStatuses: CheckinStatus[];
	handleClinicCheckinChange: (event: React.ChangeEvent) => void;
}

export const ClinicTable = ({
	checkInStatuses,
	handleClinicCheckinChange
}: ClinicTableProps) => {
	const { userClinics } = useClinicContext();

	return (
		<table className="ch-table w-full">
			<thead>
				<tr>
					<th>Centre</th>
					<th>Mobile check-in</th>
					<th>Status</th>
				</tr>
			</thead>
			<tbody>
				{userClinics &&
					userClinics.map((clinic) => {
						const checkinStatus = checkInStatuses.find(
							(checkinStatus) => checkinStatus.clinicId === clinic.id
						);
						return (
							<tr key={clinic.id}>
								<td>{clinic.name}</td>
								<td>
									<Switch
										id={clinic.id.toString()}
										checked={checkinStatus?.status}
										onChange={handleClinicCheckinChange}
										name={clinic.name}
									/>
								</td>
								<td>{checkinStatus?.status ? "Open" : "Closed"}</td>
							</tr>
						);
					})}
			</tbody>
		</table>
	);
};
